<ng-container *ngIf="shouldShowSidebarAndHeader(); else loginContent">
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav-content>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</ng-container>

<!-- Conteúdo de login sem sidebar -->
<ng-template #loginContent>
  <router-outlet></router-outlet> 
</ng-template>